<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="userForm"
          :model="userForm"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="nickName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="登录账号">
            <el-input
              v-model="loginName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input
              v-model="userForm.newPwd"
              show-password
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="newPwdConfirm">
            <el-input
              v-model="userForm.newPwdConfirm"
              show-password
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm('userForm')">确认</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import ZJUser from "../user";
import { resetUserPwd } from "@/api/system/permission/user";
export default {
  name: "ZjChangePasswd",
  data() {
    let validateNewPassword = (rule, value, callback) => {
      if (value !== this.userForm.newPwd) {
        callback(new Error("与新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      nickName: ZJUser.current.nickName,
      loginName: ZJUser.current.LoginName,
      userForm: {
        newPwd: "",
        newPwdConfirm: "",
      },
      rules: {
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        newPwdConfirm: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validateNewPassword, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    OnConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("是否确认修改密码?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            let userId = ZJUser.current.UserId;
            let password = this.userForm.newPwd;
            resetUserPwd({ userId:userId, password:password }).then(response => {
              this.$message({type: "success", message: "修改密码成功"});
              this.$emit("changeSuccess", {});
            });
          }).catch(() => {});
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
  },
};
</script>

<style></style>
